import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";

import "./styles/tokens.css";
import "./styles/globals.css";

import "./i18n/i18n";
import { setLanguage } from "./i18n/i18n";

import "./assets/fonts/fonts.css";
import "./styles/tokens.css";
import "./styles/globals.css";

(async () => {
  await setLanguage("ar"); // default
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </React.StrictMode>
  );
})();
